import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const CTA = () => {
  return (
    <section className="relative px-4 py-20 md:py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-[linear-gradient(180deg,#f9f7ff_0%,#f2edff_42%,#fdfbff_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_18%,rgba(99,102,241,0.10),transparent_22%),radial-gradient(circle_at_82%_82%,rgba(168,85,247,0.08),transparent_22%)]" />

      {/* Blobs */}
      <div className="absolute -top-24 left-[-70px] w-72 h-72 bg-indigo-200/20 rounded-full blur-3xl" />
      <div className="absolute bottom-[-110px] right-[-80px] w-80 h-80 bg-purple-200/20 rounded-full blur-3xl" />

      {/* Subtle texture */}
      <div className="absolute inset-0 opacity-[0.03] [background-image:radial-gradient(#0f172a_0.8px,transparent_0.8px)] [background-size:22px_22px]" />

      <div className="relative max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8"
        >
          {/* LEFT — Hire */}
          <div className="relative rounded-[32px] p-8 md:p-10 bg-white/75 backdrop-blur-xl border border-white/80 shadow-[0_18px_45px_rgba(15,23,42,0.06)] overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-100/30 via-transparent to-purple-100/20" />

            <div className="relative">
              <h3 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
                Need Help at Home?
              </h3>

              <p className="text-gray-600 mb-6 text-sm md:text-base leading-relaxed">
                Find trusted professionals for your home in a simple and reliable way.
              </p>

              <a href="/hire">
                <button className="inline-flex items-center gap-2 px-6 py-3.5 rounded-2xl bg-indigo-600 text-white font-semibold shadow hover:shadow-lg hover:scale-[1.03] transition">
                  Hire Help
                  <ArrowRight className="w-4 h-4" />
                </button>
              </a>
            </div>
          </div>

          {/* RIGHT — Jobs */}
          <div className="relative rounded-[32px] p-8 md:p-10 bg-white/75 backdrop-blur-xl border border-white/80 shadow-[0_18px_45px_rgba(15,23,42,0.06)] overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-sky-100/30 via-transparent to-indigo-100/20" />

            <div className="relative">
              <h3 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-3">
                Looking for Work?
              </h3>

              <p className="text-gray-600 mb-6 text-sm md:text-base leading-relaxed">
                Apply easily and connect with trusted families and employers.
              </p>

              <a href="/jobs">
                <button className="inline-flex items-center gap-2 px-6 py-3.5 rounded-2xl border border-gray-300 bg-white text-gray-900 font-semibold hover:shadow-md hover:scale-[1.03] transition">
                  Find a Job
                  <ArrowRight className="w-4 h-4" />
                </button>
              </a>
            </div>
          </div>
        </motion.div>

        {/* Bottom subtle line */}
        <div className="mt-14 h-px w-full bg-gradient-to-r from-transparent via-slate-300 to-transparent" />
      </div>
    </section>
  );
};

export default CTA;